<template>
    <div class="clear-data-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <div class="info-box warning">
                <i class="el-icon-warning"></i>
                <div>
                    <p><strong>警告：</strong></p>
                    <ul>
                        <li>此操作将删除指定省份的所有考生数据，请谨慎操作</li>
                        <li>删除后的数据无法恢复，请确保已备份重要数据</li>
                        <li>删除范围包括考生信息、成绩、志愿、照片、体检表等相关数据</li>
                    </ul>
                </div>
            </div>

            <el-form :model="Model" label-width="140px" class="clear-form">
                <el-form-item label="选择省份" prop="Province">
                    <el-select v-model="Model.Province" placeholder="请选择要清除数据的省份" style="width: 100%;" filterable>
                        <el-option v-for="item in ProvinceOptions" :key="item.Name" :label="item.DisplayText" :value="item.Name"></el-option>
                    </el-select>
                    <span class="error-text" v-if="!Model.Province">请选择省份</span>
                </el-form-item>

                <el-form-item>
                    <el-button type="danger" size="large" :disabled="!Model.Province || Status.IsSubmiting" @click="OnClearData" :loading="Status.IsSubmiting">
                        <span v-if="!Status.IsSubmiting">确认清除</span>
                        <span v-else>清除中...</span>
                    </el-button>
                </el-form-item>
            </el-form>

            <div v-if="Result" class="result-container">
                <el-divider>操作结果</el-divider>
                <div v-html="Result" class="result-content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';

    export default {
        name: 'ClearData',
        inject: ['Loading', 'LoadingCompleted'],
        data: function () {
            return {
                Status: {
                    LoadingCompleted: false,
                    IsSubmiting: false
                },
                Model: {
                    Province: ''
                },
                ProvinceOptions: [],
                Result: ''
            }
        },
        methods: {
            OnYearChange() {
                this.LoadProvinceList();
            },
            OnLoad: function () {
                var that = this;
                that.LoadProvinceList();
                that.Status.LoadingCompleted = true;
            },
            LoadProvinceList: function () {
                var that = this;
                var api_name = "/Public/GetImportedProvinces";
                var url = TYBM_Env.GetApiUrl(api_name);
                
                TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载省份列表' }).then(result => {
                    that.ProvinceOptions = result.data;
                }).catch(() => {
                    that.ProvinceOptions = [];
                });
            },
            OnClearData: function () {
                var that = this;
                if (!that.Model.Province) {
                    that.$message.warning('请选择省份');
                    return;
                }

                that.$confirm('此操作将删除【' + that.Model.Province + '】的所有考生数据，是否继续？', '警告', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var api_name = "/Data/ClearDataByProvince";
                    var data = { "Province": that.Model.Province };
                    var year = this.$root.currentYear || '';
                    var url = TYBM_Env.GetApiUrl(api_name) + (year ? '?year=' + year : '');
                    
                    that.Status.IsSubmiting = true;
                    TYBM_Tools.AxiosPostEx(that, api_name, url, data, { loading_msg: '正在处理', has_progress: true })
                        .then(result => {
                            that.Result = result.data.Msg;
                            that.$message.success('清除成功');
                            that.Model.Province = '';
                            that.LoadProvinceList();
                        })
                        .catch(() => {
                            that.$message.error('清除失败');
                        })
                        .finally(() => {
                            that.Status.IsSubmiting = false;
                        });
                }).catch(() => {});
            }
        },
        created: function () {
            var that = this;
            that.OnLoad();
            this.$root.$on('global-year-change', this.OnYearChange);
        },
        beforeDestroy() {
            this.$root.$off('global-year-change', this.OnYearChange);
        }
    }
</script>

<style scoped>
.clear-data-container {
    max-width: 900px;
}

.clear-form {
    margin-top: 24px;
}

.info-box {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border-left: 4px solid;
    display: flex;
    gap: 12px;
}

.info-box.warning {
    background-color: #fef0f0;
    border-color: #f56c6c;
    color: #c0392b;
}

.info-box i {
    font-size: 20px;
    margin-top: 2px;
}

.info-box ul {
    margin: 8px 0 0 20px;
    padding: 0;
}

.info-box li {
    margin: 4px 0;
}

.error-text {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    display: block;
}

.result-container {
    margin-top: 32px;
}

.result-content {
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 8px;
    border: 1px solid #e4e7ed;
    min-height: 100px;
    max-height: 500px;
    overflow-y: auto;
}
</style>